// Operator-facing message for a failed admin action. Shared by the user / device
// action bars so 403s surface their DISTINCT backend codes (handler/common.go):
// IMPERSONATION_DENIED and ADMIN_REGION_MISMATCH must not be lumped into the
// generic RBAC wording — that mislabels a missing case_id or a cross-region
// target as "no permission" and sends the operator down the wrong path.

import { ApiError } from '../../lib/api';

export function actionErrorMessage(e: unknown): string {
  if (!(e instanceof ApiError)) return '操作失敗，請稍後再試。';
  switch (e.code) {
    case 'INVALID_PHONE':
      return '手機格式不正確，請使用 E.164 格式（例如 +886935068727）。';
    case 'INVALID_RESET_CHANNEL':
      return '密碼重設通道不正確，僅支援 Email 或 SMS。';
    case 'RESET_CHANNEL_UNAVAILABLE':
      return '此重設通道尚不可用，請確認手機已設定且 SMS provider 已啟用。';
  }
  if (e.status === 403) {
    switch (e.code) {
      case 'IMPERSONATION_DENIED':
        return '模擬登入遭拒：此操作僅限 full admin，且必須填寫案件編號（case_id）。（IMPERSONATION_DENIED）';
      case 'ADMIN_REGION_MISMATCH':
        return '區域不符：目標帳號／裝置隸屬其他 region，僅能由該 region 的管理員操作。（ADMIN_REGION_MISMATCH）';
      default:
        return `權限不足：伺服器拒絕了這項操作（RBAC，${e.code}）。`;
    }
  }
  return `${e.message}（${e.code}）`;
}
